import type { Diagram } from '@pharmafiche/schema';
import { Suspense, lazy } from 'react';

/**
 * Code-split entry point for the React-Flow-backed PathwayDiagram. Templates
 * import THIS instead of PathwayDiagram so @xyflow/react (≈70 kB gzipped)
 * only enters the bundle when a fiche actually contains a diagram.
 */
const PathwayDiagram = lazy(() =>
  import('./PathwayDiagram').then((m) => ({ default: m.PathwayDiagram })),
);

interface LazyPathwayDiagramProps {
  diagram: Diagram;
}

export function LazyPathwayDiagram({ diagram }: LazyPathwayDiagramProps) {
  return (
    <Suspense
      fallback={
        <div
          style={{
            height: 360,
            border: '2.5px solid #1f2330',
            borderRadius: 14,
            background: 'rgba(255,255,255,.55)',
            boxShadow: '3px 4px 0 #1f2330',
          }}
          className="grid place-items-center font-hand text-ink-soft text-[14px]"
        >
          <span>⌛ Chargement du diagramme…</span>
        </div>
      }
    >
      <PathwayDiagram diagram={diagram} />
    </Suspense>
  );
}
